export enum TextbausteinLinkRel {
	UPDATE_TRANSIENT_TEXT = 'updateTransientText',
}

export enum TextbausteineListLinkRel {
	TEXTBAUSTEINE_LIST = 'textbausteinList',
}
